import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { getStatesList, getAllStatesProvincesList } from './api'
import { StoreData } from '@user/store/reducers/typings'
import { StateProvince } from './typings'

const statesAdapter = createEntityAdapter<StateProvince>({
  selectId: (state) => state.abbreviation,
})

export const initialState = {
  states: statesAdapter.getInitialState(),
  allStates: statesAdapter.getInitialState(),
}

export const dictionaries = createSlice({
  name: 'dictionaries',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getStatesList.fulfilled, (state, action) => {
      statesAdapter.addMany(state.states, {
        ...action,
        payload: action.payload.map((state) => ({
          ...state,
          id: state.abbreviation,
        })),
      })
    }),
      builder.addCase(getAllStatesProvincesList.fulfilled, (state, action) => {
        const updatedPayload = action.payload.map((x) => ({
          ...x,
          id: x.abbreviation,
        }))
        statesAdapter.setAll(state.allStates, updatedPayload)
      })
  },
})

export default dictionaries.reducer

export const statesAdapterSelectors = statesAdapter.getSelectors<StoreData>(
  (state) => state.dictionaries.states,
)

export const { selectAll: selectAllStates } = statesAdapterSelectors

export const allStatesAdapterSelectors = statesAdapter.getSelectors<StoreData>(
  (state) => state.dictionaries.allStates,
)

export const { selectAll: selectAllStatesProvinces } = allStatesAdapterSelectors
